import { handleSendFunctionResponseToShotListAgent } from "../services/handleSendFunctionResponseToShotListAgent";
import { addIdentifierToShots } from "./addIdentifierToShots";
import { updateShotListHistory } from "./updateShotListHistory";    

export const addNewShot = async (
  newShot,
  updatedChatSession,
  shotListState,
  setShotListState,
  setChatSession,
  userInfo,
  shotListHistory,
  setShotListHistory,
  historyIndex,
  setHistoryIndex
) => {
  const updatedShotListState = [...shotListState];
  console.log("addNewShot updatedShotListState", newShot);
  const shotObject = newShot.shot;
  const index = newShot.index;

  const firstHalf = updatedShotListState.slice(0, index);
  const secondHalf = updatedShotListState.slice(index);
  const newShotListState = [...firstHalf, shotObject, ...secondHalf];
  const updatedWithIndexes = addIdentifierToShots(newShotListState);
  console.log("addNewShot updatedWithIndexes", updatedWithIndexes);
  updateShotListHistory(
    shotListState,
    setShotListState,
    shotListHistory,
    setShotListHistory,
    historyIndex,
    setHistoryIndex,
    updatedWithIndexes
  );
    const responseMessage = `FunctionResponse: The new shot has been added. Here is the updated shot list: ${JSON.stringify(newShotListState, null, 2)}. Let me know if you want to make further changes or need suggestions.`;
    const response = {
        role: "user",
        parts: [
            {
                text: responseMessage
            }
        ]
    };
    await handleSendFunctionResponseToShotListAgent(response, updatedChatSession, setChatSession, userInfo);
}